module.exports = __webpack_public_path__ + "static/media/comparison4.8e94e9f9.png";